// extracted by mini-css-extract-plugin
export default {"root":"rKNCE","avatar":"KLwxh","name":"Kw40P","follow":"hPGjf","stats":"FURS4","stat":"Swrls","icon":"k7t1s","link":"vldXZ","diamonds":"KaugX","followers":"SX4PU"};